module.exports = __webpack_public_path__ + "img/ttsMarket1.0f55e4a4.png";